import { Component, OnInit } from '@angular/core';
import { EventService } from '../../../services/api/EventService';
import { EventModel } from '../../../models/api/EventModel';
import { Router, RouterModule } from '@angular/router';
import { A11yModule } from "@angular/cdk/a11y";
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-active-upcoming-events',
  standalone: true,
  imports: [RouterModule, A11yModule, DatePipe, MatButtonModule, MatIconModule],
  templateUrl: './active-upcoming-events.component.html',
  styleUrl: './active-upcoming-events.component.scss'
})
export class ActiveUpcomingEventsComponent implements OnInit {

  public eventsList: EventModel[] = [];

  public activeEventsList: EventModel[] = [];
  public upcomingEventsList: EventModel[] = [];

  public isLoaded: boolean = false;

  constructor(
    private eventService: EventService,
    private router: Router,
  ) {

  }

  ngOnInit(): void {

    this.eventService.getActiveEvents().subscribe({
      next: (data) => {
        this.eventsList = data;
        const dateUtcNow = new Date();

        this.activeEventsList = this.eventsList.filter(
          x =>
            (x.eventStatusID === 1 || x.eventStatusID === 2) &&
            new Date(x.startDate) <= dateUtcNow &&
            new Date(x.endDate) >= dateUtcNow
        );

        this.upcomingEventsList = this.eventsList.filter(
          x =>
            (x.eventStatusID === 1 || x.eventStatusID === 2) &&
            new Date(x.startDate) > dateUtcNow
        );
        this.isLoaded = true;

      },
      error: (err) => {
      }
    })

  }

  goToEventDashboard(eventID: number){
    this.router.navigate(['admin', 'events', eventID]);
  }

  goToAllEvents(){
    this.router.navigate(['admin', 'events', 'all-events']);
  }

}
